import * as React from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import StringHelper from '../../utils/StringHelper'
import sizeMe from 'react-sizeme';
import styled from '../../utils/styled'
import LayoutTemplate from '../../components/layout/IndexLayout'

import Page from '../../components/layout/Page'
import Container from '../../components/layout/Container'
import DataTable from '../../components/layout/DataTable'
import Loadingbar from '../../components/layout/Loaderbar'
import StackGrid from "react-stack-grid";
import { Waypoint } from 'react-waypoint';
import Moment from 'react-moment';
import { ApplicationState, ConnectedReduxProps } from '../../store'
import { Blogs } from '../../store/blogs/types'
import { fetchRequest, bulkUpdate } from '../../store/blogs/actions'
import { Dispatch } from 'redux'
import * as Scroll from 'react-scroll';
import { animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
  loading: boolean
  data: Blogs[]
  errors?: string
}
interface InterfaceProps {
  users?: any
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest
  bulkUpdate: typeof bulkUpdate
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps & InterfaceProps

class BlogsIndexPage extends React.Component<AllProps> {
  constructor(props: any) {
    super(props)

    this.state = {
      loading: false,
      Blogs: []
    }
    this.scrollHandler = this.scrollHandler.bind(this)

  }
  public componentDidMount() {
    const { data } = this.props

    if (data.length === 0) {
      this.props.fetchRequest(null)
      // this.props.bulkUpdate()
    }

  }
  private scrollHandler(event:any) {
      const { loading, data } = this.props;
      if (!loading) {
        // console.log("loading", data[data.length-1])
        this.props.fetchRequest(data);
      }
  }
  public render() {
    const { loading, size, data, fetchRequest } = this.props

    return (
      <LayoutTemplate loading={loading} title={'BLOGS'} subtitle={'Archive'} logo={'none'}
      size={size} data={data} category={'blogs'} fetchRequest={fetchRequest} />)
  }
  private toTop(event:any) {
    scroll.scrollTo(0, {smooth: true});
  }

  private handleBlog(event:any) {
    const  route = $(event.currentTarget).attr("to")
    this.props.history.push(route);
  }
  private renderGallery() {
    const { loading, data, size } = this.props
    // if (data!=null)
    // data = data.map(item => item.data())
    // console.log("data", data)
    return (
       <Region>
       <HeadRegion>
         <Title>BLOGS</Title>
        <Subtitle>ARCHIVE</Subtitle>
     </HeadRegion>
      <StackGrid  duration={0}  style={{ margin: '5%' }}
      columnWidth={size.width<600 ? "100%" : "33%"}>
      {Array.isArray(data) && data.map((item,index) => (<ImageLink key={index} role="button" onClick={this.handleBlog.bind(this)} to={`/blogs/${(item.url_name)}`}
      colSpan={index%2==0 ? 1.5: (1.5)} columnWidth={index==0 ? "100%" : "30%"}>
        <Card>
          {index==(data.length-1) && (<Waypoint onEnter={this.scrollHandler}></Waypoint>)}
          <Front><Image
            background={ item.hasOwnProperty('cover') ? item['cover']!=null ?  item.cover.url : undefined: 'none' }
            alt="image"
            theme={{ padding: '5px' }}
          />
          <ImageInfo>
            <ImageLabel>{item.name}</ImageLabel>
            <ImageYear><Moment format="YYYY" date={item.startDate}/></ImageYear>
            <ImageDescription>{item.description}</ImageDescription>
            {item.hasOwnProperty('category') && (<ImageCategory>{ item.category.name}</ImageCategory>)}
          </ImageInfo>
          </Front>
          <Back><Icon key={index}
            background={ item.hasOwnProperty('cover') ? item['cover']!=null ?  item.cover.url : undefined : 'none' }
          />
          <h1>{item.name}</h1>
          {item.description}</Back>
          </Card>
          </ImageLink>)}
          </StackGrid>
          </Region>)

      }

private renderData() {
    const { loading, data } = this.props
    return (
        <DataTable columns={['Name', 'Description']} widths={['auto', '']}>
          {loading && data.length === 0 && (
            <itemLoading>
              <td colSpan={3}>Loading...</td>
            </itemLoading>
          )}
          {data.map(item => (
            <tr key={item.id}>
              <itemDetail>
                <itemName>
                  <Link to={`/blogs/${StringHelper(item.name)}`}>{item.name}</Link>
                  {item.hasOwnProperty('cover') ? <img src={item.cover.url} /> : ''}
                </itemName>
              </itemDetail>

              <td>{item.description}</td>
            </tr>
          ))}
        </DataTable>
    )
  }
}


// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = ({ blogs }: ApplicationState) => ({
  loading: blogs.loading,
  errors: blogs.errors,
  data: blogs.data,
  selected: blogs.data
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchRequest: (doc?:any) => dispatch(fetchRequest(doc)),
  bulkUpdate: () => dispatch(bulkUpdate())
})

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(sizeMe()(BlogsIndexPage))


const Region = styled('div')`
background-color: rgba(0,0,0,1);
height: 100vh;
`

const HeadRegion = styled('div')`
padding: 10% 0rem 2%  0rem;
margin: 0em;
color: white;
text-align: center;
`
const Title= styled('h1')`
margin: 0em;
font-size: 3.5rem;
font-weight: 200;
`
const Subtitle= styled('span')`
text-align: center;
font-size: 1.5rem;
font-weight: 300;
`
const BackToTop = styled('a')`
text-align: center;
font-size: 1rem;
font-weight: 300;
    cursor: pointer;
    text-align: center;
    width: 100%;
    display: block;
    padding: 1rem 0rem;
}
`

const ImageLink = styled('a')`
   pointer-events: auto;
  height: ${props => `${props.colSpan*300}px`};
  /* min-width: ${props => `${props.colSpan*300}px`}; */
  width: 100% ;
  overflow:hidden;
  /* min-height: 100px; */
  display: block;
  position: relative;
  z-index: 1;
  perspective: 1000;
  border:1px solid rgba(0,0,0,.2);
  cursor: pointer;
  &>div:first-child>div:first-child>div:first-child {

transition: all 600ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
transform:scale(1);
}
:hover>div:first-child>div:first-child>div:first-child {
transform: scale(1.1);
/* transform: rotateY(180deg); */
/* box-shadow: -5px 5px 5px #aaa; */
}
:hover>div:first-child>div:first-child>div:last-child {
transform: translateY(-100%);
/* transform: translateY(-120%); */
bottom: 0px;
background-color: rgba(255,255,255,.9);
  &>div {
  color: rgba(0,0,0,1)
  }
}
`
const Card = styled('div')`

  position:relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: all 600ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
  /* transition-delay: 300ms; */

`
const Front = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  /* background-color: #aaa; */
  background-color: #aaa;
  transform: rotateY(0deg);
`
const Back = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  display: block;
  transform: rotateY(180deg);
  box-sizing: border-box;
  padding: 10px;
  color: white;
  text-align: center;
  background-color: #171526;
  font-size: 12px;
`

const ImageInfo = styled('div')`
  width: 100%;
  position:relative;
  bottom: 60px;


  background-color: rgba(255,255,255,1);
  padding: .5em .5em 1em .5em;
  color: rgba(0,0,0,1);

  transition: all 300ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
`
const ImageLabel = styled('div')`
  width: 100%;
  position:relative;
  text-transform: uppercase;
 font-weight: bold;
`

const ImageYear = styled('div')`
  width: 100%;
  position:relative;
  text-transform: uppercase;
 color: rgba(50,50,50,1);
`
const ImageCategory = styled('div')`
  width: 100%;
  position:relative;
  text-transform: uppercase;
 color: rgba(50,50,50,1);
`
const ImageDescription = styled('div')`
  width: 100%;
  position:relative;
  font-size: .8em;

`

const Image = styled('div')`
  width: 100%;
  height: 100%;
  background-image: ${props => `url(${props.background})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`
const Icon = styled('div')`
  width: 100px;
  height: 100px;
  display: block;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,1);
  margin: 20px auto;
  background-image: ${props => `url(${props.background})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;


`
